import type { GridValidRowModel } from "@mui/x-data-grid-premium";
import type { AccountingBook } from "../../../../../../../../../api/types/svTypes.ts";
import { DimensionNames } from "../../../../../utilities/DimensionNames.ts";
import { toConditionValue, toRowId } from "@entrilia/shared/components/reporting/text-filter-grid/filterGridHelper.tsx";
import type { TextFilterGridGrouping } from "@entrilia/shared/components/reporting/text-filter-grid/textFilterGridTypes.ts";

const GROUP_ID_SEPARATOR = "\u001f";
const ACCOUNTING_BOOK_FIELD = "Accounting Book";

interface Params {
  isMultiBook: boolean;
  dimensionName: string;
  keyFieldName: string;
  books: AccountingBook[];
}

export const getTextFilterGrouping = ({
  isMultiBook,
  dimensionName,
  keyFieldName,
  books,
}: Params): TextFilterGridGrouping | undefined => {
  const isGroupedDimension = dimensionName === DimensionNames.AccountNo || dimensionName === DimensionNames.AccountName;
  if (!isMultiBook || !isGroupedDimension) {
    return undefined;
  }

  const bookNames = Object.fromEntries(books.map((book) => [book.code, book.name]));
  return {
    groupField: ACCOUNTING_BOOK_FIELD,
    leafField: keyFieldName,
    getGroupKey: (value: unknown) => toRowId(value == null ? null : String(value)),
    getGroupLabel: (value: unknown) => {
      const key = toConditionValue(String(value));
      return key === null ? "Memo" : (bookNames[key] ?? key);
    },
    getRowId: (row: GridValidRowModel) => {
      const groupId = toRowId(row[ACCOUNTING_BOOK_FIELD] == null ? null : String(row[ACCOUNTING_BOOK_FIELD]));
      const leafId = toRowId(row[keyFieldName] == null ? null : String(row[keyFieldName]));
      return `${groupId}${GROUP_ID_SEPARATOR}${leafId}`;
    },
  };
};
